import './tabs-mobile.scss';

import { SELECT_LIST } from "../menu-left/constants/select";

//material
import { Box, Grid } from '@mui/material';
import Icon from '../shared/components/icon/icon';


export function TabsMobile({ selectData, changeSection, section }: { selectData: any, changeSection: (sectionChange: number) => void, section: number }) {

    let list: any[] = [];
    SELECT_LIST.forEach((el: any) => {
        list.push({ id: el.id, text: el.text, textLabel: el.text, class: `${section === el.id ? 'selected' : ''} list-item`, icon: el.icon, iconWidth: el.iconWidth, iconHeight: el.iconHeight, iconHeightMobile: el.iconHeightMobile });
    })
    const sectionChange = (index: number) => {
        changeSection(index);
    }

    return (
        <div className='tabs-mobile'>
            <Box sx={{ display: 'flex', justifyContent: 'center', width: '90%' }}>
                {list.map((item: any) => (
                    <Grid item key={item.text} xs={6} sm={4} md={3} display={'flex'}>
                        <button
                            type="button"
                            onClick={() => sectionChange(item.id)}
                            className={item.class}
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                paddingTop: '5px',
                                paddingBottom: '0px',
                                padding: '10px',
                                width: 'max-content',
                                margin: 'auto',
                                flex: '1'
                            }}
                        >
                            <Icon
                                name={item.icon}
                                width={item.iconWidth}
                                height={item.iconHeightMobile}
                                color={item.class === 'selected list-item' ? '#f82e4b' : '#747474'}
                            />
                            <span style={{ fontSize: 'calc(0.5em + 1vw)' }}>{item.text}</span>
                        </button>
                    </Grid>
                ))}
            </Box>
        </div >
    );
}
